export const getWhatsAppConnectionAvailability = (plan) => ({
  qrcode: Boolean(plan?.useWhatsapp),
  officialEmbedded: Boolean(plan?.useWhatsappOfficial),
  officialManual: Boolean(plan?.useWhatsappOfficial),
});
